import { render, staticRenderFns } from "./round.vue?vue&type=template&id=5f9e14ea&scoped=true&"
import script from "./round.vue?vue&type=script&lang=ts&"
export * from "./round.vue?vue&type=script&lang=ts&"
import style0 from "./round.vue?vue&type=style&index=0&id=5f9e14ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9e14ea",
  null
  
)

export default component.exports